var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportDatas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23.911,
    viewBox: "0 0 24 23.911",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.911,24H9.95a2,2,0,0,1-1.991-2V17A1,1,0,1,1,9.95,17v5H21.911V2H9.95V7A1,1,0,1,1,7.959,7V2A2,2,0,0,1,9.95,0H21.911A2,2,0,0,1,23.9,2V22A2,2,0,0,1,21.911,24ZM3.391,11h13.53a1,1,0,0,1,0,2H3.391l2.284,2.293a1,1,0,0,1,0,1.414.992.992,0,0,1-1.408,0l-3.983-4a1,1,0,0,1-.291-.7s0-.005,0-.007,0,0,0-.006a1,1,0,0,1,.075-.376,1.014,1.014,0,0,1,.216-.326l3.983-4a.992.992,0,0,1,1.408,0,1,1,0,0,1,0,1.414Z",
    transform: "translate(24 0.009) rotate(90)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportDatas);
export default __webpack_public_path__ + "static/media/export-datas.82b477d9a81a0619ec8f9b42c4067484.svg";
export { ForwardRef as ReactComponent };